import { HistoryMap, History, Parents } from 'types';

const SEPARATOR = '#';

export const createParentsKey = ([father, mother]: Parents) => `${ father }${ SEPARATOR }${ mother }`;
export const parentsFromKey = (key: string) => key.split(SEPARATOR);
export const fromArrayToObject = (array: History): HistoryMap =>
  array.reduce((result, entry) => {
    const key = createParentsKey([entry.father, entry.mother]);
    result[key] = entry.timestamp;

    return result;
  }, {} as HistoryMap);
